import { createSelector } from '@reduxjs/toolkit';

import { selectIsAppConfigRetrievedSuccessful } from 'features/app-config/store';
import { isRnsConnectionSuccessSelector } from 'features/app/store/app/selectors';
import type { RootState } from 'features/app/store/store';
import { selectIsNoLanguageSelected } from 'features/queue-settings/store';
import {
  selectIsVpnDetected,
  selectIsVpnRestrictionBypassed,
} from 'features/vpn-behavior/store';

export const rnsConnectionIdSelector = (state: RootState) =>
  state.session.rnsConnectionId;

export const sessionIdSelector = (state: RootState) => state.session.id;

export const pendingSessionSelector = (state: RootState) =>
  state.session.pendingSession;

export const isRnsSessionStartedSelector = (state: RootState) =>
  state.session.isRnsSessionStarted;

export const selectNumberOfConsecutiveAnswerTimeouts = (state: RootState) =>
  state.session.numberOfConsecutiveAnswerTimeouts;

export const sessionRemovalStatusSelector = (state: RootState) =>
  state.session.sessionRemovalStatus ?? 'idle';

export const isSessionStartAvailableSelector = createSelector(
  selectIsAppConfigRetrievedSuccessful,
  selectIsNoLanguageSelected,
  isRnsConnectionSuccessSelector,
  selectIsVpnDetected,
  selectIsVpnRestrictionBypassed,
  (
    isAppConfigRetrievedSuccessful,
    isNoLanguageSelected,
    isRnsConnectionSuccess,
    isVpnDetected,
    bypassVpnRestrictions
  ) => {
    return (
      isAppConfigRetrievedSuccessful &&
      !isNoLanguageSelected &&
      isRnsConnectionSuccess &&
      (bypassVpnRestrictions || !isVpnDetected)
    );
  }
);
